import script from "./HangBox.vue?vue&type=script&setup=true&name=HangBox&lang=js"
export * from "./HangBox.vue?vue&type=script&setup=true&name=HangBox&lang=js"

import "./HangBox.vue?vue&type=style&index=0&id=7d00a204&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d00a204"]])

export default __exports__